import { datadogLogs, Logger } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import { getRuntimeEnvironment } from './getRuntimeEnvironment';

const isProductionBuild = import.meta.env.MODE === 'production';
const environment = getRuntimeEnvironment();

const redactUrlToken = (url: string): string =>
  url.replace(/([?&]token=)[^&]*/i, '$1redacted');

if (isProductionBuild) {
  datadogLogs.init({
    clientToken:
      environment === 'production'
        ? 'pub9261def376866274b6f8dd2110e956af'
        : 'pub2c8313b495a7561771cb5b194d2f2503',
    site: 'datadoghq.com',
    service: 'signup',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    version: import.meta.env.VITE_RELEASE,
  });

  datadogRum.init({
    applicationId:
      environment === 'production'
        ? 'e0dec811-ec68-4f36-859e-577d02a711f9'
        : '3768eb32-cd8a-4ecf-b373-84ee4636b419',
    clientToken:
      environment === 'production'
        ? 'pub40fa89f55e6ea6a18fc3b03f385b1e80'
        : 'pub5d8c4b3f680f77265f69b13dbce1a4aa',
    site: 'datadoghq.com',
    service: 'signup',
    version: import.meta.env.VITE_RELEASE,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: true })],
    beforeSend: (event) => {
      // Meta in-app browsers (Facebook, Instagram) inject a script that
      // fetches a relative URL "properties". CSP correctly blocks it, but
      // the violation surfaces as a noisy error in RUM. Not iwoca code,
      // not actionable. See NAT-3200.
      if (
        event.type === 'error' &&
        event.error?.message?.startsWith("csp_violation: 'properties'")
      ) {
        return false;
      }

      if (event.view.url) {
        event.view.url = redactUrlToken(event.view.url);
      }
      if (event.view.referrer) {
        event.view.referrer = redactUrlToken(event.view.referrer);
      }
      if (event.type === 'resource' && event.resource.url) {
        event.resource.url = redactUrlToken(event.resource.url);
      }

      return true;
    },
  });
}

export default (isProductionBuild
  ? datadogLogs.logger
  : { ...console }) as Logger;
